import React, { FC } from 'react';

import cx from 'classnames';

import { IInputGroupProps } from '../types';
import styles from './index.module.css';

const InputGroup: FC<IInputGroupProps> = ({ children, twoCol = false }) => {
  const childrenLength = children?.length;

  if (childrenLength > 1) {
    return (
      <div className={cx(styles.inputGroup, twoCol && styles.inputGroupTwoCol)}>
        {children.map((child: any, i: number) => (
          <div key={i} className={styles.inputGroupItem}>
            {child}
          </div>
        ))}
      </div>
    );
  }

  return <div className={styles.inputGroup}>{children}</div>;
};

export default InputGroup;
